import { loginRoot } from '../config'
import vue from 'vue'

function url (api) {
    return loginRoot + '/'+api
}

// 验证码
export function forgetverification_api (data) {
    // console.log(data)
    return vue.http({
        method: 'post',
        url: url('forgetverification'),
        body:{
            email:data
        }
    })
}

// 获取缓存验证码
export function forgetverifi_api(data) {
    return vue.http({
        method: 'post',
        url: url('forgetverifi'),
        body:{
            email:data
        }
    })
}


//修改密码
export function updatepass_api(data){
    return vue.http({
        method: 'post',
        url: url('updatepass'),
        body:{
            data
        }
    })
}
